<!--
 * @Description:
 * @Author: WangYuhan
 * @Date: 2023-06-30 10:36:20
 * @LastEditTime: 2024-07-01 15:49:59
 * @LastEditors: lijinpeng
-->
<template>
  <el-scrollbar class="app-main" :style="[{ height: `calc(100vh - ${headerHeight}px - 20px)` }]">
    <keep-alive :include="cachedViews">
      <router-view :key="key" />
    </keep-alive>
  </el-scrollbar>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews;
    },
    key() {
      return this.$route.path;
    },
    // 头部固定高度
    headerHeight() {
      return this.$store.state.settings.headerHeight;
    },
  },
};
</script>

<style lang="scss" scoped>
.app-main {
  width: calc(100% - 20px);
  height: calc(100vh - 145px);
  overflow: hidden;
  background-color: #f4f7fa;
  margin: 10px;
}

.fixed-header + .app-main {
  margin-top: 60px;
}

.hasTagsView {
  .fixed-header + .app-main {
    padding-top: 36px;
    padding-bottom: 0;
  }
}
.main-container {
  background-color: #f4f7fa;
}
</style>
